// extracted by mini-css-extract-plugin
export var buttonContent = "_3x-0";
export var centered = "_3x-1";
export var centeredFlex = "_3x-2";
export var errorText = "_3x-3";
export var icon = "_3x-4";
export var iconButtonContent = "_3x-5";
export var monospace = "_3x-6";
export var padded = "_3x-7";